import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';
import { ItineraryHistoryService } from '../services/itinerary-history.service';
import { of } from 'rxjs';

function loadItineraryHistory(
  pnr: string,
  gds: string,
  api: APIService,
  layoutService: LayoutService,
  itineraryHistoryService: ItineraryHistoryService,
  itineraryService: ItineraryService
) {
  return api.getItineraryClassicHistory(pnr, gds).pipe(
    map((response) => {
      layoutService.dispatchChangeBreadcrumb(pnr, OptionType.ItineraryHistory);
      itineraryHistoryService.dispatchLoadItineraryHistorySuccess(response);
      return !!response;
    }),
    catchError((response) => {
      itineraryService.dispatchGenericError(response);
      itineraryService.navigateToWithParams('itinerary/info');
      return of(false);
    })
  );
}

export const ItineraryHistoryGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const api = inject(APIService);
  const itineraryService = inject(ItineraryService);
  const itineraryHistoryService = inject(ItineraryHistoryService);
  const layoutService = inject(LayoutService);

  return loadItineraryHistory(
    route?.queryParams?.pnr,
    route?.queryParams?.gds,
    api,
    layoutService,
    itineraryHistoryService,
    itineraryService
  );
};
